import React from 'react';
import './NotificationDisplay.css';

interface ErrorItem {
  message: string;
  field?: string;
}

interface ErrorDisplayProps {
  errors: ErrorItem[];
  className?: string;
  onClose?: () => void;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ errors, className = '', onClose }) => {
  if (!errors || errors.length === 0) return null;

  return (
    <div className={`error-display ${className}`}>
      <div className="error-container">
        <div className="error-header">
          <div className="error-header-left">
            <i className="fas fa-exclamation-triangle error-icon"></i>
            <span className="error-title">Please check and correct the following:</span>
          </div>
          {onClose && (
            <button 
              type="button" 
              className="error-close-btn"
              onClick={onClose}
              aria-label="Close error message"
            >
              <i className="fas fa-times"></i>
            </button>
          )}
        </div>
        <div className="error-list">
          {errors.map((error, index) => (
            <div key={index} className="error-item">
              <div className="error-bullet"></div>
              <span className="error-message">
                {error.field && error.field !== 'general' && (
                  <strong className="error-field">{error.field}: </strong>
                )}
                {error.message}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ErrorDisplay; 